/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  ICalendarOutputFilterOptions,
  ICalendarOutputDaysWithDeadlines,
  ICalendarOutputDeadline,
  ICalendarOutputActivity,
} from '../types/response.types'

export default new class CalendarAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_FilterOptions(
  ): Promise<ICalendarOutputFilterOptions> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/calendar/filter-options`,
    })
  }
  public async get_DaysWithDeadlines(
    entity_id: number,
    people_ids: string,
    start_date_range: string,
    end_date_range: string,
  ): Promise<ICalendarOutputDaysWithDeadlines> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/calendar/days-with-deadlines`,
      params: {
        entity_id,
        people_ids,
        start_date_range,
        end_date_range,
      },
    })
  }
  public async get_Deadlines(
    entity_id: number,
    people_ids: string,
    date: string,
  ): Promise<ICalendarOutputDeadline[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/calendar/deadlines`,
      params: {
        entity_id,
        people_ids,
        date,
      },
    })
  }
  public async get_Activities(
    entity_id: number,
    people_ids: string,
    date: string,
  ): Promise<ICalendarOutputActivity[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/calendar/activities`,
      params: {
        entity_id,
        people_ids,
        date,
      },
    })
  }
}()
